<template>
  <div class="alert">
    <div class="mask" @touchmove.prevent></div>
    <div class="alert-box" v-if="type === ''">
      <slot></slot>
      <img
        @click="close"
        class="close"
        src="../assets/images/toast_btn.png"
        alt=""
      />
    </div>
    <div class="alert-box1" v-else>
      <slot></slot>
      <img
        @click="close"
        class="close"
        src="../assets/images/toast_btn.png"
        alt=""
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "alertPage",
  props: {
    type: {
      type: String,
      default: "",
    },
  },
  methods: {
    close() {
      this.$emit("close", "close");
    },
  },
};
</script>
<style lang="less" scoped>
.alert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 98;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
  }
  .alert-box {
    position: relative;
    width: 7rem;
    height: 4rem;
    .close {
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .tips {
      width: 7.5rem;
      height: 4.85rem;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-image: url("../assets/images/tips.png");
      top: 50%;
      left: 50%;
      position: absolute;
      transform: translate(-50%, -50%);
    }
  }
  .alert-box1 {
    position: relative;
    width: 7rem;
    height: 7rem;
    .close {
      position: absolute;
    right: 5%;
    top: 0;
      // transform: translateX(-50%);
      cursor: pointer;
      width: 1rem;
      height: 1rem;
    }
  }
}
</style>